import { HTMLAttributes, ReactNode } from 'react';
import styles from './Badge.module.scss';
import { classes } from '../../../lib/utils/cssUtils';

export type BadgeProps = {
  variant: 'warn' | 'success' | 'info' | 'regular';
  ariaLabel?: string;
  role?: string;
  children: ReactNode;
} & HTMLAttributes<HTMLSpanElement>;

const Badge = ({ children, role, className, variant, ...props }: BadgeProps) => {
  return (
    <span role={role ?? 'status'} {...props} className={classes(styles.badge, className, styles[variant])}>
      {children}
    </span>
  );
};

export default Badge;
